import { __assign, __read, __rest, __spread } from "tslib";
import React from "react";
import classNames from "classnames";
import { LoadingIcon } from "@tencent/tea-icons-react";
import { Tooltip } from "../tooltip";
import { Icon } from "../icon";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { useConfig } from "../_util/config-context";
import { ButtonGroup } from "./ButtonGroup";
export var Button = forwardRefWithStatics(function (props, ref) {
    var disabled = props.disabled, icon = props.icon, loading = props.loading, _type = props.type, _variant = props.variant, _theme = props.theme, _size = props.size, _shape = props.shape, className = props.className, style = props.style, onClick = props.onClick, children = props.children, tooltip = props.tooltip, htmlType = props.htmlType, buttonProps = __rest(props, ["disabled", "icon", "loading", "type", "variant", "theme", "size", "shape", "className", "style", "onClick", "children", "tooltip", "htmlType"]);
    var classPrefix = useConfig().classPrefix;
    var type = _type;
    var variant = _variant || "outlined";
    var theme = _theme || "neutral";
    var size = _size || "md";
    var shape = _shape || "rectangle";
    // 计算类名
    var btnClassName = classPrefix + "-btn";
    var classList = [classPrefix + "-btn"];
    // 指定了图标的话，
    if (icon) {
        type = "icon"; // 保留旧的calss
    }
    if (!type && !icon && !_variant && !_theme && !_size && !_shape) {
        classList.push(btnClassName + "--weak"); // 保留旧的calss，如果业务对组件有样式覆盖，确保还能生效
        variant = "outlined";
        theme = "neutral";
        size = "md";
        shape = "rectangle";
    }
    // 类型类名
    switch (type) {
        case "primary":
            variant = "solid";
            theme = "brand";
            break;
        case "weak":
            variant = "outlined";
            theme = "neutral";
            break;
        case "pay":
            variant = "solid";
            theme = "warning";
            break;
        case "error":
            variant = "solid";
            theme = "error";
            break;
        case "text":
            variant = "plain";
            theme = "neutral";
            break;
        case "link":
            variant = "link";
            theme = "brand";
            break;
        case "icon":
            variant = _variant || "plain";
            theme = _theme || "neutral";
            size = _size || "md";
            shape = _shape || "square";
            break;
        case "secondary":
            variant = "soft";
            theme = "neutral";
            break;
    }
    if (type !== "primary" && typeof type !== "undefined") {
        classList.push(btnClassName + "--" + type);
    }
    // 状态类名
    classList.push([
        btnClassName + "--" + variant,
        btnClassName + "--" + theme,
        btnClassName + "--" + size,
        btnClassName + "--" + shape,
    ], {
        "is-disabled": disabled,
        "is-loading": loading,
    });
    // 用户自定义类名
    if (className) {
        classList.push(className);
    }
    // 控制台内，交互规范不允许的变体和主题组合
    if ((variant === "solid" && theme === "neutral") ||
        (variant === "outlined" && theme === "brand") ||
        (variant === "outlined" && theme === "warning") ||
        (variant === "outlined" && theme === "error") ||
        (variant === "plain" && theme === "warning") ||
        (variant === "plain" && theme === "error") ||
        (variant === "link" && theme === "warning") ||
        (variant === "link" && theme === "error")) {
        console.warn("Button does not support the combination of " + variant + " variant and " + theme + " theme, please use other variants or themes");
    }
    /* eslint-disable react/button-has-type */
    var button = (React.createElement("button", __assign({ ref: ref, className: classNames.apply(void 0, __spread(classList)), onClick: (!disabled && !loading && onClick) || null, style: style || {}, type: htmlType, disabled: disabled }, buttonProps),
        loading && React.createElement(LoadingIcon, { size: 16 }),
        icon ? React.createElement(Icon, { type: icon }) : children));
    /* eslint-enable react/button-has-type */
    if (tooltip) {
        button = React.createElement(Tooltip, { title: tooltip }, button);
    }
    return button;
}, {
    defaultLabelAlign: "middle",
    Group: ButtonGroup,
});
Button.displayName = "Button";
//# sourceMappingURL=Button.js.map